export enum EventFeature {
  PREMIUM_DESIGN_TOOLS = 'premium-design-tools',
  TITLE = 'title',
  DATE = 'date',
  LOCATION = 'location',
  HOST_DETAILS = 'host-details',
  GUESTS_OF_HONOR = 'guests-of-honor',
  ADDITIONAL_LINKS = 'additional-links',
  HOST_NOTE = 'host-note',
  RSVPS = 'rsvps',
  HOST_PHOTO_GALLERY = 'host-photo-gallery',
  PHOTO_SHARING = 'photo-sharing',
  ADS = 'ads',
  WISHLIST = 'wishlist',
  GIFT_IDEAS = 'gift-ideas',
  CHARITY = 'charity',
  CROWDFUNDING = 'crowdfunding',
  POLLS = 'polls',
  WHAT_TO_BRING = 'what-to-bring',
}
